export default __webpack_public_path__ + "static/media/a016-6.9f53fc97.png";